export default __webpack_public_path__ + "static/media/pta.1aff0e59.png";